<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-6">
                    <h2>Money Line</h2>
                    </div>
                    <div class="col-lg-6 col-6 text-right bid">
                    <div>
                        <button class="btn btn-success rounded dropdown-toggle ml-2 mt-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <div>
                            <i class="fas fa-tasks"></i>  Actions
                          </div>  
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a class="dropdown-item cursor-pointer" @click="exportToExcel()" ><i class="fas fa-download"></i>Export</a>
                          <a class="dropdown-item cursor-pointer" @click="exportToExcelAll()"> <i class="fas fa-download"></i>Export All</a>
                          <a class="dropdown-item cursor-pointer" @click="importData()"><i class="fas fa-upload"> </i>Import</a>
                          <a class="dropdown-item cursor-pointer" @click="toggleAddCustomerOpen()"><i class="fas fa-plus"> </i>Add prospect</a>
                        </div>
                    </div>
                    <!-- <button type="button" @click="exportToExcel()" class="btn btn-warning rounded ml-1"> <i class="fas fa-download"></i> EXPORT</button>
                    <button type="button" @click="exportToExcelAll()" class="btn btn-danger rounded ml-1"> <i class="fas fa-download"></i> EXPORT ALL</button> -->
                    <!-- <button type="button" @click="importData()" class="btn btn-success rounded ml-1"> <i class="fas fa-upload"></i> IMPORT</button> -->
                    <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                        <i @click="searchMoneyLine()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchMoneyLine" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>              
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="mt-2">Filters</h5>
              <span class="btn btn-outline-secondary" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Cash Available Greater than $</label>
                    <input id="filter" v-model="amountFilter" type="number" class="form-control"  >
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Include margin account?</label>
                    <select v-model="isMarginAcount" class="form-control" >
                      <option value="true">YES</option>
                      <option value="false">NO</option>
                    </select> 
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Active account?</label>
                    <select v-model="isExport" class="form-control" >
                      <option value="true">YES</option>
                      <option value="false">NO</option>
                    </select> 
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Primary Rep</label>
                    <multiselect 
                        v-model="primaryRep" 
                        placeholder="Select" 
                        :options="representativeData" 
                        :multiple="false" 
                        label="firstName" 
                        track-by="id" >
                        </multiselect>
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Secondary Rep</label>
                    <multiselect 
                        v-model="secondaryRep" 
                        placeholder="Select" 
                        :options="representativeData" 
                        :multiple="false" 
                        label="firstName" 
                        track-by="id" >
                        </multiselect>
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Note</label>
                    <input id="filter" v-model="noteFilter" type="text" class="form-control"  >
                    
                  </div>
                  <div class="col-md-4 col-lg-2">
                    <button @click="getMoneyLineList()" type="button" class="btn btn-success">Filter</button>
                  </div>
                </form>
                
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'account'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'account'  ? 'sort-desc' : '']"  
                                    @click="sort('account')">Account</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'fbsiShortName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'fbsiShortName'  ? 'sort-desc' : '']"  
                                    @click="sort('fbsiShortName')">fbsi <br> Short Name</th>     
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cashOnlyAvailableToTradeHist'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cashOnlyAvailableToTradeHist'  ? 'sort-desc' : '']"  
                                    @click="sort('cashOnlyAvailableToTradeHist')"
                                    >Cash Only <br> AvailableTo  <br> Trade Hist</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'ims'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'ims'  ? 'sort-desc' : '']"  
                                    @click="sort('ims')"
                                    >IMS <br> Cash <br> Available</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidAccumulator '  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidAccumulator '  ? 'sort-desc' : '']"  
                                    @click="sort('bidAccumulator ')"
                                    >BID ACCUMULATOR  <br> Cash <br> Available</th>         
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cashOnlyAvailableTotal'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cashOnlyAvailableTotal'  ? 'sort-desc' : '']"  
                                    @click="sort('cashOnlyAvailableTotal')"
                                    >Cash Only <br> Available  <br> Total</th>      
        
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'isMargin'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'isMargin'  ? 'sort-desc' : '']"  
                                    @click="sort('isMargin')"
                                    >Is Margin</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'pmp'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'pmp'  ? 'sort-desc' : '']"  
                                    @click="sort('pmp')"
                                    >Pmp</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'noteLastEditedDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'noteLastEditedDate'  ? 'sort-desc' : '']"  
                                    @click="sort('noteLastEditedDate')"
                                    >Note <br><span class="text-info">Last updated on</span></th>                               
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'balanceDateHist'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'balanceDateHist'  ? 'sort-desc' : '']"  
                                    @click="sort('balanceDateHist')"
                                    >Balance <br> Date <br> Hist</th>   
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cashCreditDebitHist'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cashCreditDebitHist'  ? 'sort-desc' : '']"  
                                    @click="sort('cashCreditDebitHist')"
                                    >Cash <br> CreditDebit <br> Hist</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'regType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'regType'  ? 'sort-desc' : '']"  
                                    @click="sort('regType')"
                                    >RegType</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturity'  ? 'sort-desc' : '']"  
                                    @click="sort('maturity')" >Maturity</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'spread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'spread'  ? 'sort-desc' : '']"  
                                    @click="sort('spread')" >Spread</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'contact'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'contact'  ? 'sort-desc' : '']"  
                                    @click="sort('contact')" >Contact</th>
                                 <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'eod'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'eod'  ? 'sort-desc' : '']"  
                                    @click="sort('eod')" >EOD</th> 
                                    <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'primaryRepName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'primaryRepName'  ? 'sort-desc' : '']"  
                                    @click="sort('primaryRepName')" >Primary Rep</th>
                                    <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'secondaryRepName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'secondaryRepName'  ? 'sort-desc' : '']"  
                                    @click="sort('secondaryRepName')" >Secondary Rep</th>          
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >Action</th>    
                                    
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="totalRows == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in moneyLineData" :key="data.id" v-bind:class="{'row-highlight-red' : data.isMargin == 'YES'}">
                                <td>{{data.account}}</td>
                                <td v-if="data.account != 'PROSPECT'">{{data.fbsiShortName}}</td>
                                <td v-if="data.account == 'PROSPECT'">{{data.customerLastName}}</td>
                                <td>{{data.cashOnlyAvailableToTradeHist | currency}}</td>
                                <td>
                                  <div class="required">
                                    <span>{{data.ims | currency}}</span>
                                    <span v-if="data.ims != 0" class="ml-highlight"><i class="fas fa-asterisk"></i></span>
                                  </div>  
                                </td>
                                <td>
                                  <div class="required">
                                    <span>{{data.bidAccumulator  | currency}}</span>
                                    <span v-if="data.bidAccumulator  != 0" class="ml-highlight"><i class="fas fa-asterisk"></i></span>
                                  </div>  
                                </td>
                                <td>{{data.cashOnlyAvailableTotal | currency}}</td>
                                <td>{{data.isMargin}}</td>
                                <td>{{data.pmp}}</td>
                                <td>
                                  <span v-b-tooltip.hover v-bind:title='data.note' >{{data.note | truncate(20, '...')}}</span> <br> 
                                  <span class="text-info">{{data.noteLastEditedDate ? moment(data.noteLastEditedDate).format('MM/DD/YYYY h:mm:ss a') : ''}}</span>
                                </td>
                                <td>{{data.balanceDateHist ? moment(data.balanceDateHist).format('MM/DD/YYYY') : 'N/A'}}</td>
                                <td>{{data.cashCreditDebitHist | currency}}</td>
                                <td data-toggle="tooltip" data-placement="left"  v-bind:title='data.regType'>{{data.regType | truncate(20, '...')}}</td>
                                <td>{{data.maturity}}</td>
                                <td>{{data.spread}}</td>
                                <td>{{data.contact}}</td>
                                <td>{{data.eod}}</td>
                                <td>{{data.primaryRepName}}</td>
                                <td>{{data.secondaryRepName}}</td>
                                <td class="text-center">
                                  <a   @click="openMoneyLineEditPoup(data)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                                </td>

                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getMoneyLineList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <moneylineimport
          v-if="moneyLineModalOpen"
          @close="closeMoneyLinePoup()"
        ></moneylineimport>
        <moneylineedit
          v-if="moneyLineEditModalOpen"
          v-bind:moneylinedata="selectedData"
          @close="closeMoneyLineEditPoup()"
        ></moneylineedit>
        <AddCustomer
          v-bind:customerData="customerData"
          v-bind:addAsProspect="true"
          v-if="addCustomerModalOpen"
          @close="toggleAddCustomerOpen()"
        ></AddCustomer>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import moneylineimport from './MoneyLineImportModal.vue';
import moneylineedit from './MoneyLineEditModal.vue';
import AddCustomer from "@/components/ims/ims-maintenance/ims-customers/ImsAddCustomerModal";

export default {
  name: "imsmoneylineComponent",
  components : {
      moneylineimport,
      moneylineedit,
      AddCustomer
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 50,
        searchValue : "",
        totalRows : 0,
        sortColumn: "account",
        sortOrder: "ASC",
        moneyLineData : [],
        moneyLineModalOpen : false,
        showFilters : false,
        amountFilter : 5000,
        isMarginAcount : "true",
        isExport : "true",
        moneyLineEditModalOpen : false,
        selectedData : null,
        noteFilter : "",
        addCustomerModalOpen : false,
        customerData : {},
        primaryRep : null,
        secondaryRep : null,
        representativeData : []
     
    };
  },
  methods: {
    toggleAddCustomerOpen(){
      this.customerData = {}
      this.addCustomerModalOpen = !this.addCustomerModalOpen;
      if(!this.addCustomerModalOpen){
        this.getMoneyLineList(); 
      }
    },
    closeMoneyLinePoup(){
      this.moneyLineModalOpen = false;
      this.getMoneyLineList(); 
    },
    closeMoneyLineEditPoup(){
      this.moneyLineEditModalOpen = false;
      this.getMoneyLineList(); 
    },
    openMoneyLineEditPoup(data){
      
      let accountData = {...data};
      delete accountData.secondaryRepId;
      delete accountData.primaryRepId;
      delete accountData.primaryRepName;
      delete accountData.secondaryRepName;
      delete accountData.primaryRep;
      delete accountData.secondaryRep;
      
      this.selectedData = accountData;
      this.moneyLineEditModalOpen = true; 
    },
    importData(){
      this.moneyLineModalOpen = true;
    },
    searchMoneyLine(){
      this.getMoneyLineList('','onsearch'); 
    },
    clearSearch(){
      this.searchValue = "";
      this.primaryRep = null;
      this.secondaryRep = null;
      this.getMoneyLineList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getMoneyLineList();
    },
    getMoneyLineList(currentPage,search) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      let url = "";
      if(search){
        url = "/money-line/list?page="+
            currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder ;
      }else{
        url = "/money-line/list?page="+
            currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&amountFilter="+
            this.amountFilter+
            "&isMargin="+
            this.isMarginAcount+
            "&export="+
            this.isExport+
            "&note="+
            encodeURIComponent(this.noteFilter)+
            "&primaryRepId="+
            (this.primaryRep ? this.primaryRep.id : "")+
            "&secondaryRepId="+
            (this.secondaryRep ? this.secondaryRep.id : "")
      }
      this.$http
        .get(
          config.baseUrlBidSide +
            url,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(element => {
            if(element.isMargin === null || element.isMargin === ""){
               element.isMargin = "N/A";
            }else{
              element.isMargin ? element.isMargin = "YES" : element.isMargin = "NO"
            }
            // console.log("ma",element.isMargin)
            if(element.pmp === null || element.pmp === "" ){
               element.pmp = "N/A";
            }else{
              element.pmp ? element.pmp = "YES" : element.pmp = "NO"
            }
            if(element.contact === null){
               element.contact = "N/A"
            }else{
              element.contact ? element.contact = "YES" : element.contact = "NO"
            }
            if(element.eod === null){
               element.eod = "N/A"
            }else{
              element.eod ? element.eod = "YES" : element.eod = "NO"
            }
           });
           this.moneyLineData = result.data.content;
           this.loading = false;
        })
    },
    exportToExcel(){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/money-line/excel-download"+
            "?amountFilter="+
            this.amountFilter+
            "&isMargin="+
            this.isMarginAcount+
            "&export="+
            this.isExport+
            "&note="+
            encodeURIComponent(this.noteFilter)+
            "&primaryRepId="+
            (this.primaryRep ? this.primaryRep.id : "")+
            "&secondaryRepId="+
            (this.secondaryRep ? this.secondaryRep.id : ""),
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.loading = false;
        })

    },
    exportToExcelAll(){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/money-line/excel-download",
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.loading = false;
        })

    },
    getRepresentativeList() {
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      let url = "/money-line/representative-list";
      this.$http
          .get(
          config.baseUrlAutoBidder +
              url,
              auth
          )
          .then(result => {
          this.representativeData = result.data
          })
      }
   
  },
  mounted() {
    this.getRepresentativeList();
    this.getMoneyLineList()

  }
};
</script>
<style>
.ml-highlight{
}
.ml-highlight i {
  color: red;
}
</style>